import request from '@/utils/request'

export function TypeList() {
    return request({
        url: '/product/type',
        method: 'get'
    })
}

export function AdminTypeList() {
    return request({
        url: '/admin/product/type',
        method: 'get'
    })
}

export function HandleType(param) {
    return request({
        url: '/product/type/handle',
        method: 'post',
        data: param
    })
}


export function ModelList(params) {
    return request({
        url: '/product/model',
        method: 'get',
        params: params
    })
}

export function AdminModelList(params) {
    return request({
        url: '/admin/product/model',
        method: 'get',
        params: params
    })
}

export function HandleModel(param) {
    return request({
        url: '/product/model/handle',
        method: 'post',
        data: param
    })
}

export function List(params) {
    return request({
        url: `/product/list`,
        method: 'get',
        params: params
    })
}

export function HandleProduct(params) {
    return request({
        url: `/product/handle`,
        method: 'post',
        data: params
    })
}

export function AdminList(params) {
    return request({
        url: `/admin/product/list`,
        method: 'get',
        params: params
    })
}

export function Detail(params) {
    return request({
        url: `/product/detail`,
        method: 'get',
        params: params
    })
}

export function Order(data) {
    return request({
        url: `/order`,
        method: 'post',
        data
    })
}

export function GetQiniuToken() {
    return request({
        url: `/upload_token`,
        method: 'get'
    })
}